export const productType = (code) => {
    switch(code) {
        case 1:
            return 'Produto'
        case 2:
            return 'Serviço'
        case 3:
            return 'Curso'
        default:
            return null
    }
}

export const getClassTypeNameByCode = (code) => {
    switch(code) {
        case 1:
            return 'Presencial'
        case 2:
            return 'Online'
        case 3:
            return 'InCompany'
        default:
            return null
    }
}


// WEBPACK FOOTER //
// ./src/helpers/product.js